import { useIdle } from "../../hooks/useTimeOut"
import { useToast } from "@chakra-ui/react";

const CheckTimer = ({ handleLogouts = () => null }) => {
  const toast = useToast();

  const handleTriggerWarning = () => {
    toast({
      title: `Your session will expire in 1 minute due to inactivity`,
      status: "warning",
    });
  }

  const { isIdle: isOneMinuteIdle } = useIdle({
    onIdle: handleTriggerWarning,
    idleTime: 4
  });

  const { isIdle } = useIdle({ onIdle: handleLogouts, idleTime: 5 });

  return <></>;
};

export default CheckTimer